import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import auth from './auth';
import utils from './utils';
import account from './account';
import appUserAuth from './appUserAuth';

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    auth,
    utils,
    account,
    appUserAuth
  });

export default createRootReducer;
